import { KineticHeading } from "./KineticHeading";
import { motion } from "framer-motion";

export const PageHero = ({ eyebrow, lines = [], subtitle, testId }) => (
  <section
    data-testid={testId}
    className="relative bg-navy-900 text-white pt-36 pb-16 md:pt-44 md:pb-24 overflow-hidden grain"
  >
    <div className="absolute -top-24 -right-24 w-[420px] h-[420px] rounded-full bg-navy-600/30 blur-3xl" />
    <div className="relative max-w-[1400px] mx-auto px-5 md:px-10">
      <motion.span
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className="text-xs font-bold uppercase tracking-[0.2em] text-navy-400"
      >
        {eyebrow}
      </motion.span>
      <KineticHeading
        lines={lines}
        delay={0.1}
        className="font-display font-black text-white text-[13vw] leading-[1.02] tracking-tighter sm:text-6xl lg:text-7xl mt-4"
      />
      {subtitle && (
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6 }}
          className="mt-6 max-w-xl text-lg text-slate-300"
        >
          {subtitle}
        </motion.p>
      )}
    </div>
  </section>
);
